import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subject-section-consents',
  templateUrl: './subject-section-consents.component.html',
  styleUrls: ['./subject-section-consents.component.scss']
})
export class SubjectSectionConsentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
